import { useEffect } from "react";
import { useAnimation, motion} from "framer-motion";
import { useInView } from "react-intersection-observer";

const squareVariants = {
  visible: { transform: 'rotateY(0deg)', scale: 1, transition: { duration: 1.8 } },
  hidden: { transform: 'rotateY(90deg)', scale: 0.6 }
};

const yVariants = {
  visible: { transform: 'rotateX(0deg)', scale: 1, transition: { duration: 1.8 } },
  hidden: { transform: 'rotateX(90deg)', scale: 0.6 }
};


const zVariants = {
  visible: { transform: 'rotateZ(0deg)', scale: 1, transition: { duration: 1.8 } },
  hidden: { transform: 'rotateZ(90deg)', scale: 0.6 }
};


const zoomVariants = {
  visible: {
    scale: 1, opacity: 1, transition: { duration: 1.8}
  },
  hidden: {
    scale: 0.2,
    opacity: 0.4
  }
}


export const Square = ({ children, variant }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={squareVariants}
      className="square"
    >
      {children}
    </motion.div>
  );
}

export const SquareY = ({ children, variant }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={yVariants}
      className="square"
    >
      {children}
    </motion.div>
  );
}

export const SquareZ = ({ children, variant }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={zVariants}
      className="square"
    >
      {children}
    </motion.div>
  );
}

export const Zoomer = ({ children }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);
  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={zoomVariants}
      className="square"
    >
      {children}
    </motion.div>
  );
}